import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-box-stack',
  templateUrl: './box-stack.component.html',
  styleUrls: ['./box-stack.component.scss'],
  imports: [MatIconModule],
})
export class BoxStackComponent {
  @Input() count = 0;
  constructor() {}
}
